export function initialize(options) {
  const {
    items,
    perPage,
    container,
    pager,
    renderItem,
    renderPageButton,
    renderPrevButton,
    renderNextButton,
    siblingCount = 1
  } = options;

  let currentPage = 1;
  const totalPages = Math.ceil(items.length / perPage);

  function paginate() {
    renderItems();
    renderPager();
    announce();
  }

  function renderItems() {
    const start = (currentPage - 1) * perPage;
    const pageItems = items.slice(start, start + perPage);
    container.innerHTML = pageItems.map(renderItem).join('');
  }

  function renderPager() {
    pager.innerHTML = '';

    // PREV
    if (renderPrevButton) {
      pager.insertAdjacentHTML(
        'beforeend',
        renderPrevButton(currentPage === 1)
      );
    }

    // NUMERI
    getPageRange().forEach(p => {
      if (p === '...') {
        pager.insertAdjacentHTML(
          'beforeend',
          `<li><span aria-hidden="true">…</span></li>`
        );
      } else {
        pager.insertAdjacentHTML(
          'beforeend',
          renderPageButton(p, p === currentPage)
        );
      }
    });

    // NEXT
    if (renderNextButton) {
      pager.insertAdjacentHTML(
        'beforeend',
        renderNextButton(currentPage === totalPages)
      );
    }
  }

  function getPageRange() {
    const range = [];
    const start = Math.max(2, currentPage - siblingCount);
    const end = Math.min(totalPages - 1, currentPage + siblingCount);

    range.push(1);

    if (start > 2) range.push('...');

    for (let i = start; i <= end; i++) range.push(i);

    if (end < totalPages - 1) range.push('...');

    if (totalPages > 1) range.push(totalPages);

    return range;
  }

  function announce() {
    const status = document.getElementById('pager-status');
    if (status) {
      status.textContent = `Pagina ${currentPage} di ${totalPages}`;
    }
  }

  paginate();

  pager.addEventListener(`click`, e => {
    const pageBtn = e.target.closest(`[data-page]`);
    const prevBtn = e.target.closest(`[data-prev]`);
    const nextBtn = e.target.closest(`[data-next]`);

    if (!pageBtn && !prevBtn && !nextBtn) return;

    e.preventDefault();

    if (pageBtn) {
      currentPage = Number(pageBtn.dataset.page);
      paginate();
    }

    if (prevBtn && currentPage > 1) {
      currentPage--;
      paginate();
    }

    if (nextBtn && currentPage < totalPages) {
      currentPage++;
      paginate();
    }

  });
}
